import React, { ReactElement } from "react";
import * as types from "../../types";

interface Props {
  card: types.EvergreenCardMinimal;
}

const EvergreenCard: React.FC<Props> = ({ card }: Props): ReactElement => {
  return (
    <div className="p-4">
      {card.title ? <h1 className="text-xl pb-2">{card.title}</h1> : null}
      <p>{card.text}</p>
    </div>
  );
};

export default EvergreenCard;
